module.exports = __webpack_public_path__ + "img/Tests-fotor(mid).9d0273d1.jpg";